import React, { useContext, useEffect, useState, useRef } from "react";
import "./Points.scss";
import { Box, Typography, CircularProgress } from "@mui/material";
import Icons from "../Icons";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import { getTaskList } from "../../utils/apis";
import { useLocation, useParams } from "react-router-dom";
// import { callInsightsAPI } from "../IRTask/api";
// ---------------- LOCAL TRANSLATOR ----------------
import { translation_en } from "../../translations/translation_en";
import { translation_hi } from "../../translations/translation_hi";

function getValue(obj: any, path: string) {
  return path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);
}

function useLocalTranslation() {
  const lang = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
  const dict = lang.startsWith("hi") ? translation_hi : translation_en;

  return (key: string, vars?: Record<string, any>) => {
    let text = getValue(dict, key) ?? key;

    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        text = text.replace(`{{${k}}}`, String(v));
      });
    }

    return text;
  };
}


function Pnts({ pointsData }: any) {
  const t  = useLocalTranslation();
  const { id, image_id } = useParams();
  const location = useLocation();
  const authContext: any = useContext(AuthContext);

  const apiCalledRef = useRef(false);
  const scrollPositionRef = useRef(0);
  const [insightsLoading, setInsightsLoading] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const isIR = queryParams.get("isIR") === "true";

  const totalPoints = pointsData?.points?.total_points || 0;
  const earnedPoints = pointsData?.points?.earned_points || 0;
  const totalEarnedPoints = pointsData?.total_earned_points || 0;
  const requiredApproval = pointsData?.result_details?.req_approval || false;
  const isBonus = pointsData?.bonus_point > 0;
  const showCoin = earnedPoints > 0;

  const [taskList, setTaskList] = useState({
    completed_tasks: [],
    active_tasks: [],
    upcoming_tasks: [],
  });

  // ==== RESTORE SCROLL ====
  useEffect(() => {
    if (scrollPositionRef.current !== null) {
      window.scrollTo({ top: scrollPositionRef.current });
    }

    return () => {
      scrollPositionRef.current = window.scrollY;
    };
  }, []);

  // ==== CALL INSIGHTS API FOR IR ====
  // useEffect(() => {
  //   if (image_id && authContext && !apiCalledRef.current) {
  //     apiCalledRef.current = true;
  //     const { token } = authContext;
  //     setInsightsLoading(true);

  //     callInsightsAPI(image_id, token)
  //       .then((data) => {
  //         console.log("Insights API response:", data);
  //       })
  //       .catch((err) => console.error("Insights error:", err))
  //       .finally(() => setInsightsLoading(false));
  //   }
  // }, [image_id, authContext]);

  // ==== FETCH TASK LIST ====
  useEffect(() => {
    const fetchData = async () => {
      if (authContext) {
        const token = localStorage.getItem("token") || "";
        try {
          const data = await getTaskList(token);
          setTaskList({
            completed_tasks: data.completed_tasks?.tasks || [],
            active_tasks: data.active_tasks?.tasks || [],
            upcoming_tasks: data.underreview_tasks?.tasks || [],
          });
        } catch (error) {
          console.error("Failed to fetch tasks:", error);
        }
      }
    };
    fetchData();
  }, [authContext]);

  // ======================================================================
  // 1️⃣ PRIORITY: IR SUCCESS VIEW
  // ======================================================================
  if (isIR) {
    return (
      <Box
        sx={{
          background: isBonus
            ? "transparent"
            : "linear-gradient(179.88deg, rgba(255,248,187,0) 21.44%, rgba(220,220,106,0.32) 106.48%)",
          position: "relative",
          backgroundImage: isBonus ? "url(/images/Bg_results_diwali.png)" : "auto",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          paddingTop: isBonus ? "65px !important" : "auto",
        }}
        className="congrats"
      >
        <Box sx={{ padding: "40px", textAlign: "center" }}>
          <Icons name="home" />
          <Typography variant="h6" sx={{ mt: 2 }}>

            {t("taskdetaitls.watch_videos.result.message")}
          </Typography>
          <Typography className="status-type">
            {t("status_type.status_review")}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: "#666" }}>
            {/* {t("taskdetaitls.watch_videos.result.sub_message")} */}
          </Typography>
        </Box>
      </Box>
    );
  }

  // ======================================================================
  // 2️⃣ NORMAL POINTS UI (UNCHANGED)
  // ======================================================================
  return requiredApproval ? (
    <Box
      sx={{
        background: isBonus
          ? "transparent"
          : "linear-gradient(179.88deg, rgba(255,248,187,0) 21.44%, rgba(220,220,106,0.32) 106.48%)",
        position: "relative",
        backgroundImage: isBonus ? "url(/images/Bg_results_diwali.png)" : "auto",
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        paddingTop: isBonus ? "65px !important" : "auto",
      }}
      className="congrats"
    >
      {insightsLoading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
          }}
        >
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Processing insights...
          </Typography>
        </Box>
      )}

      {isBonus ? <Icons name={"coin_Mascot_diwali"} /> : <Icons name={"home"} />}

      <Typography className="totalpoint2" variant="body2">
        {t("taskdetaitls.availability.result.message")}
      </Typography>

      <Box sx={{ margin: isBonus ? "12px !important" : "auto" }}>
        <Typography className="status-type">
          {t("status_type.status_review")}
        </Typography>
        <Typography className="message">
          {t("taskdetaitls.availability.result.sub_message", {
            points: totalPoints,
          })}
        </Typography>
      </Box>
    </Box>
  ) : (
    <Box
      sx={{
        background: isBonus
          ? "transparent"
          : "linear-gradient(179.88deg, rgba(255,248,187,0) 21.44%, rgba(220,220,106,0.32) 106.48%)",
        position: "relative",
        backgroundImage: isBonus ? "url(/images/Bg_results_diwali.png)" : "auto",
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
      }}
      className="congrats"
    >
      {insightsLoading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 10,
          }}
        >
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Processing insights...
          </Typography>
        </Box>
      )}

      {showCoin ? (
        isBonus ? (
          <Icons name={"coin_Mascot_diwali"} />
        ) : (
          <Icons name={"home"} />
        )
      ) : (
        <Icons name={"sadCoin"} />
      )}

      <Typography
        className="totalpoint"
        variant="body2"
        sx={{ color: isBonus ? "#FFFFFF !important" : "auto" }}
      >
        {earnedPoints === 0 && totalPoints === 0
          ? t("taskdetaitls.educational.result.message_feedback")
          : showCoin
            ? t("taskdetaitls.educational.result.message_positive")
            : t("taskdetaitls.educational.result.message_negative")}
      </Typography>

      {earnedPoints === 0 && totalPoints === 0 ? (
        <Typography
          className="pts"
          sx={{ color: showCoin ? "#46C65A" : "#E68819", fontSize: "20px" }}
          variant="h1"
        >
          {t("taskdetaitls.educational.result.sub_message_feedback")}
        </Typography>
      ) : (
        <Typography className="pts" sx={{ color: showCoin ? "#46C65A" : "#E68819" }} variant="h1">
          {earnedPoints}
          <span style={{ fontSize: "32px" }}>/</span>
          <span style={{ fontSize: "24px" }}>{totalPoints} pts</span>
        </Typography>
      )}

      {earnedPoints === 0 && totalPoints !== 0 && (
        <Box className="grey-flex">
          <Box className="card">
            <Icons name={"qaIcon"} width={34} height={34} />
            <Typography className="caption1" variant="caption1">
              <span>
                {pointsData?.result_details?.correct_answer}/
                {pointsData?.result_details?.total_questions_answered}
              </span>{" "}
              {t("taskdetaitls.educational.result.question_answered")}
            </Typography>
          </Box>

          <Box className="card">
            <Icons name={"qaIcon2"} width={34} height={34} />
            <Typography className="caption1" variant="caption2">
              <span>{totalEarnedPoints}</span>
              {t("taskdetaitls.educational.result.point_balance")}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default Pnts;